<template>
  <div class='buttons adpButtons'>
    <div product>
        <img :src="ProductImage"/>
        <ul v-for="(row,index) in KeyMap" :line='index'>
            <el-tooltip v-for="(item,i) in row" :key="i" manual :ref="'tooltip-' + item.index" class="item" effect="dark" :content="$t('msg.tooltip')" placement="top">
                <li :class='{"on": curIndex === item.index}' @click="addClassOn(item.index)" fn="1" isset="1" j="0" r="0" c="0" v-if="item.key_name"  
                :cname="item.name"  
                :name="item.key_name"
                :journey="getWorkingMode(item.working_mode)">
                    
                    <i class="el-icon-circle-check"></i>
                    <i style="background-color: transparent; opacity: 0.5;"></i>
                    <div box>
                            <!-- <h2>{{item.working_mode}}</h2> -->
                            <p>{{getWorkingMode(item.working_mode)}}</p>
                    </div>
                </li>
            </el-tooltip>
        </ul>
    </div>

  </div>
</template>
<script>


import cmd10 from '../../../../../theme/cmd1.0.config.json';

export default {
  name: 'ADButtonC',
  components: 
  {

  },
  data() {

    return {
      HIDDeviceObj:null,
      KeyMap: [],
      indexes:0,
      curIndex:-1,
      showTooltip: false,
      clickId: '',
      ProductImage:null
    }
  },
  mounted() 
  { 

  },
  created() 
  {
	document.addEventListener('dblclick', this.handleClick);
  },
  updated()
  {

    
  },
  methods: 
  {
    initMap(map)
    {
      this.KeyMap = map;
    },
    getWorkingMode(mode)
    {
        mode = mode & 0x0F ;
        switch(mode)
        {
          case parseInt(cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_MODE_CODE.DKS):
          {
            return "DKS";
          }break;
          case parseInt(cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_MODE_CODE.SOCD):
          {
            return "SOCD";
          }break;
          case parseInt(cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_MODE_CODE.MPT):
          {
            return "MPT";
          }break;
          case parseInt(cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_MODE_CODE.MT):
          {
            return "MT";
          }break;
          case parseInt(cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_MODE_CODE.END):
          {
            return "END";
          }break;
          case parseInt(cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_MODE_CODE.TGL):
          {
            return "TGL";
          }break;
          case parseInt(cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_MODE_CODE.RS):
          {
            return "RS";
          }break;
        }


        return "";
    },
    //获取设备图片
    setProductImagePath()
    {
        this.ProductImage = require("../../../../drives/" + this.HIDDeviceObj.curDeviceMode + "/asserts/image/product_k.png");
        import ("../../../../drives/" + this.HIDDeviceObj.curDeviceMode + "/asserts/css/keyboard.css");
        import ("../../../../drives/" + this.HIDDeviceObj.curDeviceMode + "/asserts/css/buttonBGXY.css");
    },
    // 点击其它地方隐藏tooltip
	  handleClick() 
    {
        if(this.clickId>-1)
        {
            this.$refs[`${'tooltip-' + this.curIndex}`][0].showPopper = false;
            this.clickId = -1;
            this.curIndex = -1;
        }
    },
    addClassOn(index)
    {
        if(this.$refs[`${'tooltip-' + index}`][0].$el.getAttribute("name")== "FN")
        {
            this.$message({message:this.$i18n.t("msg.FNMody"),type: 'warning',center: true,offset:500,duration:1000});
            return false;
        }

        if(this.curIndex>-1)
        {
            this.$refs[`${'tooltip-' + this.curIndex}`][0].showPopper = false;
        }
        
        this.curIndex = index;
        this.clickId  = index;
        // 只切换当前的tooltip显示/隐藏
        this.$refs[`${'tooltip-' + index}`][0].showPopper = true;
        setTimeout(()=>{this.$refs[`${'tooltip-' + index}`][0].showPopper = false;},1000);

    }
  },
  computed: 
  {

    
  }
}
</script>